import styled from 'styled-components';
import { Text } from 'ui-components';

export const Wrapper = styled.div`
  /* HACK: Fullbleed by counteracting padding from app/app.styles.js:Page */
  margin: -20px -20px 0;

  background-color: ${({ theme }) => theme.palette.gray.main};
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const FakeModal = styled.div`
  width: 362px;
  padding-bottom: 30px;
  background: ${({ theme }) => theme.palette.common.white};
  box-shadow: 0px 2px 6px ${({ theme }) => theme.palette.gray.main};
  border-radius: 10px;
  overflow: hidden;

  display: flex;
  flex-direction: column;
  align-items: center;
`;

export const Header = styled.h3`
  box-sizing: border-box;
  width: 100%;
  background-color: ${({ theme }) => theme.palette.primary.lighter};
  padding: 10px 30px;
  margin: 0;
`;

export const Title = styled(Text).attrs({ type: 'subtitle1' })`
  color: ${({ theme }) => theme.palette.primary.dark};
  flex: 1;
`;

export const Body = styled.p`
  width: 250px;
  margin-bottom: 30px;
  font-size: 14px;
  line-height: 18px;
  text-align: center;
`;

export const UaDetectFallback = styled(Body)`
  margin: unset;
  ul {
    margin: unset;
    padding-inline-start: unset;
    li {
      text-align: left;
    }
  }
`;
